import styledImport from '@emotion/styled';
import { Bold, Medium, Regular, SemiBold } from '@src/apps/styles/common-style';

const styled = (styledImport as any).default || styledImport;

const WelcomeModalStyle = styled('div')({
    'div': {
        margin: '0',
        padding: '0',
        border: '0',
        fontSize: '100%',
        verticalAlign: 'baseline',
    },
    'p': {
        margin: '0',
        padding: '0',
    },
    '.welcome-modal-close-icon': {
        width: '100%',
        position: 'relative',
        top: '-18px',
        left: '5px',
    },
    '.close-icon': {
        float: 'right',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fill: 'currentColor',
        height: '24px',
        width: '24px',
        overflow: 'hidden',
        fontSize: '30px',

        '&:hover': {
            borderRadius: '4px',
            backgroundColor: '$pattens-blue',
        },
    },

    '.main-container': {
        width: '637px',
        textAlign: 'center',
        padding: '24px 56px',
    },
    '.list-heading-list': {
        color: '#2d2d39',
        wordBreak: 'break-word',
        fontFamily: Bold,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'left',
        display: 'flex',
    },
    '.list_content': {
        color: '#2d2d39',
        fontFamily: Medium,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        wordBreak: 'break-word',
    },

    '.layout_header_container_title_content': {
        fontSize: '36px',
        lineHeight: '40px',
        color: '#2d2d39',
        fontFamily: Regular,
        letterSpacing: '0px',
    },
    '.inner-card-list .layout_header_container_title_content': {
        marginTop: '8px',
    },
    '.inner-card-list .list_block': {
        marginTop: '32px',
    },
    '.inner-card-list .list_block .list': {
        display: 'flex',
        textAlign: 'left',
        marginBottom: '16px',
        height: '72px',
    },
    '.inner-card-list .list_block .list .list_container': {
        width: 'calc(100% - 96px)',
    },
    '.inner-card-list .list_block .list img': {
        marginRight: '24px',
        width: '72px',
        height: '72px',
        objectFit: 'contain',
    },

    '.column_type_card .header': {
        textAlign: 'center',
    },
    '.column_type_card .header .small_title': {
        color: '#757588',
        fontFamily: Medium,
        fontSize: '14px',
        lineHeight: '18px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
    },
    '.column_type_card .header .layout_header_container_title_content': {
        marginTop: '8px',
    },
    '.column_type_card .blocks': {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'left',
        marginTop: '32px',
    },
    '.column_type_card .blocks .right-block': {
        width: '306px',
        margin: '0px 12px 0px 0px',
    },
    '.column_type_card .blocks .left-block': {
        width: '306px',
        margin: '0px 0px 0px 12px',
    },
    '.column_type_card .blocks .heading': {
        height: 'auto',
    },
    '.column_type_card .blocks .image-block': {
        marginTop: '16px',
    },
    '.column_type_card .blocks img': {
        width: '304px',
        height: '304px',
        objectFit: 'contain',
        borderRadius: '4px',
    },

    '.carousel_block': {
        marginTop: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '.carousel_block .carousel_dots': {
        display: 'flex',
        alignItems: 'center',
    },
    '.carousel_block .carousel_dots .dots': {
        height: '8px',
        width: '8px',
        margin: '4px',
        backgroundColor: '#bbb',
        borderRadius: '50%',
        display: 'inline-block',
        cursor: 'pointer',
    },
    '.carousel_block .carousel_dots .dots.active': {
        height: '16px',
        width: '16px',
        backgroundColor: 'cornflowerblue',
        border: '1px solid cornflowerblue',
        color: 'white',
    },
    '.carousel_block .next_btn': {
        marginLeft: '32px',
        boxSizing: 'border-box',
        height: '40px',
        width: '81px',
        border: '1px solid #196ecf',
        borderRadius: '2px',
        backgroundColor: '#196ecf',
        color: '#ffffff',
        fontFamily: "'UHCSans-SemiBold', Helvetica, Arial, Verdana, Tahoma, sans-serif",
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'center',
        padding: '9px 24px',
        cursor: 'pointer',
    },
    '.carousel_block .prev_btn': {
        marginRight: '32px',
        boxSizing: 'border-box',
        height: '40px',
        width: '84px',
        padding: '9px 24px',
        border: '1px solid #196ecf',
        color: '#196ecf',
        borderRadius: '2px',
        fontFamily: "'UHCSans-SemiBold', Helvetica, Arial, Verdana, Tahoma, sans-serif",
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'center',
        backgroundColor: '#fff',
        cursor: 'pointer',
    },

    '.skip_for_now': {
        marginTop: '16px',
        marginBottom: '16px',
    },
    '.skip_for_now a': {
        color: '#196ecf',
        fontFamily: SemiBold,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'center',
        width: '168px',
        height: '22px',
        padding: '1px 17px',
    },

});
export default WelcomeModalStyle;

export const styles = {
    BackdropProps: {
        background: 'rgba(0, 0, 0, 0.32)',
    },
    box: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        p: '24px',
        outline: 0,
        maxWidth: '796px',
        height: 'auto',
        borderRadius: '4px',
        boxShadow: '0 11px 15px -7px #0003, 0 24px 38px 3px #00000024, 0 9px 46px 8px #0000001f',
        color: '#000000de',
    }
};
